import { render, staticRenderFns } from "./lnk-wx-image-text.vue?vue&type=template&id=2fe877ca&scoped=true&"
import script from "./lnk-wx-image-text.vue?vue&type=script&lang=js&"
export * from "./lnk-wx-image-text.vue?vue&type=script&lang=js&"
import style0 from "./lnk-wx-image-text.vue?vue&type=style&index=0&id=2fe877ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe877ca",
  null
  
)

export default component.exports